<template>
  <section id="festival">
    <h1>Festival</h1>
    <p class="aha-info" v-html="info.text">
    </p>
  </section>
</template>

<script>

export default {
  name: 'info',
  components: {
  },
  computed: {
    info () {
      return this.$store.getters.getPageByUID('festival')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

#festival {
}

</style>
